export enum AvatarSize {
  XSmall = 'xs',
  Small = 's',
  Medium = 'm',
  Large = 'l',
  XLarge = 'xl',
}
